import React from 'react';
import { ConnectedPages } from '../../_lib/components/ConnectedPages';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { IConnectedPage } from '../../types/api/connectedPages/IConnectedPage';
import ILink from '../../types/ILink';
import { ConnectedPagesMode } from '../../types/api/connectedPages/ConnectedPagesMode';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ConnectedPagesPageTypes } from '../../types/api/connectedPages/ConnectedPagesPageTypes';

type ChildPagesTree = {
  pageType: ConnectedPagesPageTypes;
  connectedPages: IConnectedPage[];
  linkToOrgUnitHome: ILink;
  initialVisibleDepth: number;
  modes: ConnectedPagesMode[];
  initialMode: ConnectedPagesMode;
};

function ChildPagesTree({
  connectedPages,
  pageType,
  modes,
  initialMode,
  initialVisibleDepth,
  linkToOrgUnitHome,
}: ChildPagesTree) {
  const { editModeInfo } = useAppContext();

  return (
    <ConnectedPages
      pageType={pageType}
      connectedPages={connectedPages}
      editModeActive={editModeInfo.active}
      linkToOrgUnitHome={linkToOrgUnitHome}
      initialVisibleDepth={initialVisibleDepth}
      modes={modes}
      initialMode={initialMode}
    />
  );
}

export const ChildPagesTreeBlock = asBlock(ChildPagesTree, BlockType.childpagestree);
